var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{class:("form_input " + _vm.extraClass),attrs:{"name":_vm.name,"id":("form_field_" + _vm.name),"required":_vm.required,"placeholder":_vm.placeholder,"rows":_vm.rows,"type":"text"}})}
var staticRenderFns = []

export { render, staticRenderFns }